module.exports = __webpack_public_path__ + "static/media/chevron-circle-up.9aa14c61.svg";